import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import Chat from '../features/Chat';
import './ChatPage.css';

export default function ChatPage() {
  const { currentUser, currentRole } = useAuth();
  const { t, isRTL } = useLanguage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const conversationId = searchParams.get('conversationId');
  const [showChatView, setShowChatView] = useState(!!conversationId);
  const [isAdmin, setIsAdmin] = useState(false);

  if (!currentUser) {
    navigate('/login');
    return null;
  }

  const handleBackToList = () => {
    setShowChatView(false);
    navigate('/chat');
  };

  const handleOpenChat = () => {
    setShowChatView(true);
  };

  useEffect(() => {
    const checkAdmin = async () => {
      if (!currentUser) return;
      try {
        let tr = await currentUser.getIdTokenResult();
        const hasAdminFromClaims = (() => {
          const claims = tr?.claims || {};
          const roles = claims.roles;
          if (Array.isArray(roles)) {
            return roles.map(String).map(r => r.toLowerCase()).includes('admin');
          }
          if (typeof roles === 'string') {
            return roles.toLowerCase() === 'admin';
          }
          return !!claims.admin;
        })();
        if (!hasAdminFromClaims) {
          tr = await currentUser.getIdTokenResult(true);
          const claims = tr?.claims || {};
          const roles = claims.roles;
          const refreshedAdmin =
            (Array.isArray(roles) && roles.map(String).map(r => r.toLowerCase()).includes('admin')) ||
            (typeof roles === 'string' && roles.toLowerCase() === 'admin') ||
            !!claims.admin;
          setIsAdmin(refreshedAdmin);
        } else {
          setIsAdmin(hasAdminFromClaims);
        }
      } catch {
        setIsAdmin(false);
      }
    };
    checkAdmin();
  }, [currentUser]);

  return (
    <div className={`chat-page ${isRTL ? 'rtl' : ''} ${showChatView ? 'chat-view-active' : 'list-view-active'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="chatpage-header">
        <div className="chatpage-header-content">
          <div className="chatpage-left">
            <button
              className="chatpage-back-button"
              onClick={() => navigate('/jobs')}
              aria-label={t('common.back')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
              <span>{t('messages.backToAllChats') || 'Back'}</span>
            </button>
          </div>
          <div className="chatpage-center">
            <div className="chatpage-title">{t('chat.title')}</div>
          </div>
          <div className="chatpage-right">
          </div>
        </div>
      </header>
      <main className="chatpage-main">
        <Chat
          initialConversationId={conversationId}
          onBackToList={handleBackToList}
          onOpenChat={handleOpenChat}
          showChatView={showChatView}
          setShowChatView={setShowChatView}
        />
      </main>
    </div>
  );
}


